import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBookmarkedJobs } from "../../store/userSlice";

const BookMarks = () => {
  const dispatch = useDispatch();
  const { bookmarkedJobs, status } = useSelector((state) => state.user);

  useEffect(() => {
    dispatch(fetchBookmarkedJobs());
  }, [dispatch]);

  return (
    <div className="applied-job-area">
      <div className="table-wrapper">
        <div className="table-title-filter">
          <div className="section-title">
            <h5>Bookmark Jobs:</h5>
          </div>
        </div>
        {status === "loading" ? (
          <p>Loading...</p>
        ) : (
          <table className="eg-table table category-table mb-30">
            <thead>
              <tr>
                <th>Job Title</th>
                <th>Deadline</th>
                <th>Hospital</th>
                <th>Location</th>
              </tr>
            </thead>
            <tbody>
              {bookmarkedJobs.length === 0 ? (
                <tr>
                  <td colSpan="4">No bookmarked jobs found.</td>
                </tr>
              ) : (
                bookmarkedJobs.map((job) => (
                  <tr key={job._id}>
                    <td>{job.jobTitle}</td>
                    <td>{job.deadline ? new Date(job.deadline).toLocaleDateString() : "-"}</td>
                    <td>{job.hospital || "-"}</td>
                    <td>{job.location || "-"}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default BookMarks;
